import * as React from "react";
import { BREAKPOINTS, deviceTierFor } from "../design/tokens";
import type { DeviceTier } from "../design/tokens";

export type { DeviceTier };

function currentTier(): DeviceTier {
  if (typeof window === "undefined") return "desktop";
  return deviceTierFor(window.innerWidth);
}

/**
 * Reports which of the three shells applies: mobile below `md`, tablet up to
 * `lg`, desktop from `lg`.
 *
 * Layout itself is done in CSS; this exists for the handful of decisions React
 * has to make, such as whether the navigation rail starts expanded.
 */
export function useDeviceTier(): DeviceTier {
  const [tier, setTier] = React.useState<DeviceTier>(currentTier);

  React.useEffect(() => {
    if (typeof window.matchMedia !== "function") {
      setTier(currentTier());
      return;
    }

    const queries = [
      window.matchMedia(`(min-width: ${BREAKPOINTS.md}px)`),
      window.matchMedia(`(min-width: ${BREAKPOINTS.lg}px)`),
    ];
    const update = () => setTier(currentTier());

    update();
    queries.forEach((query) => query.addEventListener("change", update));
    return () =>
      queries.forEach((query) => query.removeEventListener("change", update));
  }, []);

  return tier;
}
